import React from 'react';

const BottomBar = ({ currentPage }) => {
  return (
    <footer className="bottombar">
      <div className="bottombar-left">
        <div className="bottombar-status">
          <span className="status-dot" />
          <span>Connected to Power BI Service</span>
        </div>
        <span className="bottombar-sep">|</span>
        <span>Workspace: AdventureWorks Production</span>
      </div>
      <div className="bottombar-right">
        <span>Current Page: {currentPage?.label || '\u2014'}</span>
        <span className="bottombar-sep">|</span>
        <span>Last Refresh: Today 9:30 AM</span>
        <span className="bottombar-sep">|</span>
        <span>v1.0.0</span>
      </div>
    </footer>
  );
};

export default BottomBar;
